import { PDFConfig, SettingsService } from 'army-builder-shared';
import { Observable, map, distinctUntilChanged, shareReplay } from 'rxjs';
import { Injectable } from '@angular/core';

import { EQUIPMENT_TYPES } from '../fww/global/models';
import { ItemFilters, ItemSort, ItemSorts } from '../global/models';

export interface FWW_Settings {
    itemFilters: ItemFilters;
    itemSort: ItemSorts;
    disableGrouping: {
        item: {};
    };
    showIllegalItems: {
        item: boolean;
    };
    pdfConfig: PDFConfig;
    use_legacy_armour: boolean;
}
export const FWW_DEFAULT_SETTINGS: FWW_Settings = {
    itemFilters: { item: { type: EQUIPMENT_TYPES } },
    itemSort: {
        item: {
            field: 'name',
            direction: 1
        }
    },
    disableGrouping: {
        item: {}
    },
    showIllegalItems: {
        item: false
    },
    pdfConfig: null,
    use_legacy_armour: false
};

@Injectable()
export class FWWSettingsService extends SettingsService {
    fwwSettings$: Observable<FWW_Settings> = this.settings$.pipe(map((s) => s.fww ?? {}));

    itemSort$: Observable<{ [key: string]: ItemSort }> = this.settings$.pipe(
        map((s) => s.itemSort),
        distinctUntilChanged(),
        shareReplay(1)
    );

    useLegacyArmour$: Observable<boolean> = this.settings$.pipe(
        map((s) => s.use_legacy_armour),
        distinctUntilChanged(),
        shareReplay(1)
    );
}
